<!--地址选择器-->
<template>
  <div>
    <van-popup
      :style="{ height: '60%' }"
      position="bottom"
      @click-overlay="onClose"
      :close-on-click-overlay="false"
      v-model="show"
    >
      <div class="address-list-select">
        <div class="address-add-item" @click="addressAdd">新增发票抬头</div>
        <van-cell-group>
          <van-cell
            v-for="address in list"
            center
            :title="address.taitou + ' ' + address.shuihao"
            is-link
            @click="onSelect(address)" 
            :key="address.id"
          >
          </van-cell>
        </van-cell-group>
      </div>
    </van-popup>

    <van-popup
      position="bottom"
      :style="{ height: '70%' }"
      v-model="showAdd"
      @click-overlay="onClose"
    >
      <div class="address-form">
        <van-cell-group>
          <van-field
        input-align="right"
        v-model="formData.taitou"
        label="发票抬头"
        :error="formValidate && !formData.taitou"
        placeholder="请输入发票抬头"
      />
      <van-field
        input-align="right"
        v-model="formData.shuihao"
        label="税号"
        :error="formValidate && !formData.shuihao" 
        placeholder="请输入税号"
      /> 
      <van-field
        input-align="right"
        v-model="formData.account"
        label="开户行及账号" 
        :error="formValidate && !formData.account"
        placeholder="请输入开户行及账号"
      />
      <van-field
        input-align="right"
        v-model="formData.address"
        label="购买方地址" 
        :error="formValidate && !formData.address"
        placeholder="请输入购买方地址"
      /> 
      <van-field
        input-align="right"
        v-model="formData.phone"
        label="购买方电话"
        :error="formValidate && !formData.phone"
        placeholder="请输入购买方电话"
      />
        </van-cell-group>

        <div style="padding: 20px ;text-align:center">
      <van-button round size="large" @click.stop="onScan"  style="
  height: 46px; margin:0 0 10px 0"
        >扫码导入（微信发票抬头）</van-button
      >
          <van-button type="danger" round size="large" @click.stop="formSave"
            >保存</van-button
          >
        </div> 
      </div>
    </van-popup>
  </div>
</template>
<style scope>
.distinguish-btn{
  text-align: center;
  color: #4a90e2;
  margin: 0.1rem auto;
  display: block;
}
.distinguish {
  /* padding: 0 0.2rem; */
  width: 7.1rem;
  margin: 0 auto;
  border: 1px solid #f5f5f5;
  border-radius: 10px;
  overflow: hidden;
}
/*.van-popup-bottom {
      top: 40%!important;
  }*/
.address-list-select {
  /*padding: 20px 0 ;*/
  background-color: #fff;
  /*overflow-y: scroll*/
}

.address-add-item {
  /*position: relative; !*padding: 10px 18px;*!*/
  padding: 15px 18px;
  color: #4a90e2;
  font-size: 14px;
}

/*.address-add-item:after {*/
/*  content: '';*/
/*  position: absolute;*/
/*  left: 1.8rem;*/
/*  right: 0;*/
/*  bottom: 0;*/
/*  border-bottom: 1px solid #d9d9d9;*/
/*  transform: scaleY(0.5);*/
/*}*/
</style>

<script>
import areaList from "@/utils/area";
    import { Toast } from 'vant';
import { Popup, CellGroup, Cell, Switch, Area } from "vant";

export default {
  name: "AddressPicker",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    [Popup.name]: Popup,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Switch.name]: Switch,
    [Area.name]: Area,
  },
  data() {
    return {
      showAdd: false,
      distinguish_address: "",
      formData: {
        taitou: "",
        shuihao: "",
        account: "",
        address: "",
        phone: "", 
      },
      selectAddress: {},
      areaList: areaList,
      list: [],
      area_show: false,
      formValidate: false,
    };
  },

  watch: {
    show(val) {
      if (val) {
        this.getList();
      }
    },
  },
  mounted: function () {},
  methods: { 
    getList() {
      let that = this;
      this.$api.get("/api/user/invoiceList", {}, (res) => {
        console.log(res);
        let showAdd = res.data.length > 0 ? false : true;
        that.list = res.data;
        that.showAdd = showAdd;
      });
    },
    addressAdd() {
      let that = this;
      that.showAdd = true;
    },
    onSelect(address) {
      let that = this;
      that.selectAddress = address;
      that.onChange();
    },
    onClose() {
      this.showAdd = false;
      this.$emit("onClose", {});
    },

    onChange() {
      let that = this;
      // console.log('onChange',{ address: that.data.selectAddress, address_id: that.data.selectAddress.id });
      this.$emit("onChange",that.selectAddress);
      that.onClose();
    }, 

    onScan(){
      Toast('唤起扫码');
      let that = this;
      this.$api.get(
        "/api/weixin/getFapiaoTaitou",
        { 
          text: '', 
        },
        (res) => {
          console.log(res);  
          that.formData = {
            taitou: res.data.taitou,
            shuihao: res.data.shuihao,
            address: res.data.address,
            phone: res.data.phone, 
            account: res.data.account, 
            is_default: true,
          }; 
        }
      );
    },
    formSave: function () {
      let that = this;
      that.formValidate = true;
      console.log("that.formData", that.formData);
      for (let field in that.formData) {
        if (!that.formData[field] && (field == "taitou" || field == "shuihao"  || field =='phone' || field =='account' || field =='address')) {
          return;
        }
      } 
      this.$api.get(
        "/api/user/invoiceAdd",
        that.formData,
        (res) => {
          console.log(res);
          that.selectAddress = res.data;
          that.formValidate = false;
          that.formData = {
            taitou: "",
            shuihao: "",
            address: "",
            phone: "",
            account: "",
          };
          that.onChange();
        }
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// FapiaoPicker.vue?302b3bc6